import React from 'react';
import PropTypes from 'prop-types';
import Collapsible from './Collapsible';

import { plainName } from '../utils/upcomingEvents';

// Parlay picks are stored as "A, B & C"
const parlayNames = (pickName) => String(pickName || '').split(/, | & /);

const formatOdds = (odds) => {
  if (typeof odds !== 'number') return null;
  return odds > 0 ? `+${odds}` : String(odds);
};

function Corner({ name, odds, tag, align }) {
  const shown = formatOdds(odds);
  return (
    <div className={`card-corner card-corner-${align}${tag ? ' is-picked' : ''}`}>
      <span className="card-fighter">{name}</span>
      <span className="card-odds">
        {shown || <span className="card-no-line">No line yet</span>}
        {tag && <span className="card-tag">{tag}</span>}
      </span>
    </div>
  );
}

export default function FightCard({ fights, picks }) {
  if (!fights || fights.length === 0) return null;

  const straight = new Set();
  const inParlay = new Set();
  (picks || []).forEach((pick) => {
    if (String(pick.type).toLowerCase() === 'parlay') {
      parlayNames(pick.pick_name).forEach((name) => inParlay.add(plainName(name)));
    } else {
      straight.add(plainName(pick.pick_name));
    }
  });
  const tagFor = (name) => {
    const key = plainName(name);
    if (straight.has(key)) return 'Pick';
    if (inParlay.has(key)) return 'Parlay leg';
    return null;
  };

  const ordered = [...fights].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  const priced = ordered.filter((f) => typeof f.fighter_american_odds === 'number').length;

  return (
    <Collapsible title="Full card" meta={`${ordered.length} fights · ${priced} with odds`} className="fight-card">
      <ol className="fight-card-list">
        {ordered.map((fight, index) => (
          <li key={`${fight.fighter_name}-${fight.opponent_name}`} className="fight-card-row">
            <Corner name={fight.fighter_name} odds={fight.fighter_american_odds} tag={tagFor(fight.fighter_name)} align="left" />
            <div className="card-middle">
              <span className="card-vs">vs</span>
              {(index === 0 || fight.weight_class) && (
                <span className="card-meta">
                  {[index === 0 ? 'Main event' : null, fight.weight_class].filter(Boolean).join(' · ')}
                </span>
              )}
            </div>
            <Corner name={fight.opponent_name} odds={fight.opponent_american_odds} tag={tagFor(fight.opponent_name)} align="right" />
          </li>
        ))}
      </ol>
    </Collapsible>
  );
}

FightCard.propTypes = {
  fights: PropTypes.arrayOf(PropTypes.shape({
    order: PropTypes.number,
    fighter_name: PropTypes.string,
    opponent_name: PropTypes.string,
    weight_class: PropTypes.string,
    fighter_american_odds: PropTypes.number,
    opponent_american_odds: PropTypes.number,
  })),
  picks: PropTypes.arrayOf(PropTypes.object),
};
